// extracted by mini-css-extract-plugin
export default {"flex-container":"COLD2H","flexContainer":"COLD2H","flex-item":"Vo78LY","flexItem":"Vo78LY","segmented-toggle":"ViIj7d","segmentedToggle":"ViIj7d"};